import React, { useState } from 'react'
import { ChevronUpIcon, ChevronDownIcon } from '@heroicons/react/24/solid';

export default function TogglePanel({ children, name, initOpen }) {
  const [isOpen, setIsOpen] = useState(initOpen !== null ? initOpen : true);
  const togglePanel = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div className="bg-white px-4 py-5 sm:px-6">
        <div className="-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap">
          <div className="ml-4 mt-4">
            <h2 className="text-xl leading-6 font-medium text-gray-900">
              { name }
            </h2>
            <p className="mt-1 max-w-2xl text-sm text-gray-500">
            </p>
          </div>
          <div className="ml-4 mt-4 flex-shrink-0">
            <button
              className="w-full flex justify-between items-center p-2.5 rounded-xl bg-white hover:bg-gray-200 transition-colors duration-200"
              onClick={togglePanel}
            >
              {isOpen ? (
                <ChevronUpIcon className="h-5 w-5 text-gray-600" />
              ) : (
                <ChevronDownIcon className="h-5 w-5 text-gray-600" />
              )}
            </button>
          </div>
        </div>
      </div>
      { isOpen && children }
    </>
  )
}
